import _ from "lodash";
import * as z from "../../framework";
import { SignaturePopup } from "../../framework/dataComponents/components/signaturePopup";
import * as ui from "./ui";
import { userHasRight } from "../../framework";

var i = 0;

export function select(tableName) {
    var fields = $.grep(z.user.companyData.UserDefinedFields, function (data) {
        return data.TableName == tableName;
    });

    return $.map(fields, function (field) { return "," + field.BindName; }).join("");
}

function createTextareaContainer(args) {
    var containerId = args.containerPrefix + args.field.fieldId + "_container";
    var containerDiv = new ui.Container({
        id: containerId,
        screenEntityType: args.screenEntityType,
        screenName: args.screenName,
        disabled: args.disabled,
        bsc: "col-xs-12",
        zScreen: {}
    });
    containerDiv.render(args.container);
    return $("#" + containerId);
}

function createPaneRowContainer(args) {
    var containerId = args.containerPrefix + args.field.fieldId + "_container";
    var containerClasses = args.paneRowContainerClasses || "pad-l-15 pad-r-15";
    var containerDiv = new ui.Container({
        id: containerId,
        screenEntityType: args.screenEntityType,
        screenName: args.screenName,
        disabled: args.disabled,
        classes: "pane-row container " + args.classes + " " + containerClasses,
        bsc: "col-xs-12",
        readOnly: args.readonly || args.readOnly || false,
        zScreen: {}
    });
    if (args.prependPaneRowContainer) {
        containerDiv.render(args.prependPaneRowContainer, "prepend");
    } else {
        containerDiv.render(args.container);
    }

    return $("#" + containerId);
}

export function initCF(args) {
    args.change = args.change || z.util.emptyFn;
    args.bindPrefix = args.bindPrefix || "";
    args.readonly = args.readonly || args.readOnly || false;
    args.containerPrefix = args.containerPrefix || "";

    if (args.requiredRight) {
        args.rightLocked = !userHasRight(args.requiredRight);

        if (args.rightLocked) {
            args.readonly = true;
            args.required = false;
            args.disabled = true;
        }
    }

    if (args.containerPrefix) {
        args.containerPrefix = args.containerPrefix + "_";
    }

    var containerOptions = ($(args.container) && $(args.container).data("me") && $(args.container).data("me").options) || {};

    args.screenEntityType = args.screenEntityType || containerOptions.screenEntityType;
    args.screenName = args.screenName || containerOptions.screenName;
    args.sectionName = args.sectionName || containerOptions.sectionName;
    args.subType = args.subType || containerOptions.subType;
    args.disabled = args.disabled || containerOptions.disabled;
    args.prependPaneRowContainer = args.prependPaneRowContainer;
    args.includeNullSubTypes = args.includeNullSubTypes || false;

    var fields = $.grep(z.user.companyData.UserDefinedFields, function (data) {
        if (args.includeNullSubTypes && args.subType) {
            return data.TableName == args.tableName && data.ShowOnDesktop
                        && (args.subType == data.Subtype || data.Subtype == null);
        }
        return data.TableName == args.tableName && data.ShowOnDesktop;
    });

    if (args.labelsAbove) {
        fields = $.grep(fields, function (data) {
            return data.Type != "SIGNATURE" && data.Type != "URL";
        });
    }

    var selectStatement = "";

    if (fields.length > 0) {
        var textareaFields = _.filter(fields, function (data) {
            return data.Type == "TEXTAREA";
        });
        var checkboxFields = _.filter(fields, function (data) {
            return data.Type == "CHECKBOX";
        });

        fields = _.filter(fields, function (data) {
            return data.Type != "TEXTAREA" && data.Type != "CHECKBOX";
        });

        i++;
        $.each(checkboxFields, function (index, field) {
            field.fieldId = args.tableName + "CF_" + field.BindName;

            if (args.zScreen && args.zScreen.id) {
                field.fieldId = args.zScreen.id + "_" + field.fieldId;
            }

            args.field = field;
            if (!args.paneRowContainer && index == 0) {
                args.paneRowContainer = createPaneRowContainer(args);
            }

            renderCF(args);
            selectStatement += "," + field.BindName;
        });

        $.each(fields, function (index, field) {
            field.fieldId = args.tableName + "CF_" + field.BindName;

            if (args.zScreen && args.zScreen.id) {
                field.fieldId = args.zScreen.id + "_" + field.fieldId;
            }

            args.field = field;
            renderCF(args);
            selectStatement += "," + field.BindName;
        });

        $.each(textareaFields, function (index, field) {
            field.fieldId = args.tableName + "CF_" + field.BindName;

            if (args.zScreen && args.zScreen.id) {
                field.fieldId = args.zScreen.id + "_" + field.fieldId;
            }

            args.field = field;
            if (!args.textareaContainer && index == 0) {
                args.textareaContainer = createTextareaContainer(args);
            }

            renderCF(args);
            selectStatement += "," + field.BindName;
        });
    }
    return selectStatement;
}

export function renderCF(args) {
    var renderMethod = args.renderMethod || "append",
        field = args.field,
        container = args.container,
        textareaContainer = args.textareaContainer,
        paneRowContainer = args.paneRowContainer,
        textareaRenderMethod = args.textareaRenderMethod || "append",
        paneRowRenderMethod = args.paneRowRenderMethod || "append",
        buildViewArgs = {
            id: args.containerPrefix + field.fieldId,
            cf: true,
            hideSS: z.user.companyData.Settings.SupressCFSuperscript,
            bindValue: args.bindPrefix + field.BindName,
            hcLabel: field.DisplayValue,
            bsc: args.containerClasses,
            textareaBsc: args.textareaContainerClasses,
            labelBsc: args.labelClasses,
            inputBsc: args.valueClasses,
            readOnly: field.ReadOnly,
            required: field.Required,
            classes: args.classes,
            screenEntityType: args.screenEntityType,
            screenName: args.screenName,
            sectionName: args.sectionName,
            subType: args.subType,
            disabled: args.disabled,
            hcLabelAbove: undefined,
            valueWidth: undefined,
            labelWidth: undefined,
            containerWidth: undefined
        };

    field.requiredRight = args.requiredRight;

    if (args.field.ReadOnly || args.readOnly) {
        buildViewArgs.readOnly = true;
        buildViewArgs.required = false;
    }

    if (args.bindValue && field.Type != "SIGNATURE" && field.Type != "URL"  && field.Type != "CHECKBOX") {
        buildViewArgs.bindValue = args.bindValue;
        buildViewArgs.bindValue.value = args.bindPrefix + field.BindName;
    }

    if (args.labelsAbove) {
        buildViewArgs.hcLabelAbove = field.FieldName;
        buildViewArgs.valueWidth = 200;
        buildViewArgs.labelWidth = 200;
        buildViewArgs.bsc = " ";
        buildViewArgs.containerWidth = 210;
        delete buildViewArgs.hcLabel;
    }

    if (field.Type == "STRING") {
        var textbox = new ui.TextBox(buildViewArgs);
        textbox.render(container, renderMethod);
    } else if (field.Type == "TEXTAREA") {
        var textArea = new ui.TextArea(buildViewArgs);
        textArea.render(textareaContainer, textareaRenderMethod);
    } else if (field.Type == "CHECKBOX") {
        var checkbox: ui.Component;
        if (buildViewArgs.readOnly) {
            let checkArgs = _.assign({}, buildViewArgs, {
                showBox: true,
                bsc: " " // handled by pane row container
            });
            checkbox = new ui.Check(checkArgs);
        } else {
            checkbox = new ui.Checkbox(buildViewArgs);
        }
        checkbox.render(paneRowContainer, paneRowRenderMethod);
    } else if (field.Type == "INT") {
        let numericInputArgs = _.assign({}, buildViewArgs, {
            format: "n0",
            decimals: 0
        });

        var integerInput = new ui.NumericInput(numericInputArgs);
        integerInput.render(container, renderMethod);
    } else if (field.Type == "FLOAT") {
        let numericInputArgs = _.assign({}, buildViewArgs, {
            format: "n2",
            decimals: 2
        });

        var decimalInput = new ui.NumericInput(numericInputArgs);
        decimalInput.render(container, renderMethod);
    } else if (field.Type == "DATETIME") {
        let dateTimeInputArgs = _.assign({}, buildViewArgs, {
            zData: { DateFormat: "DateTime" }
        });

        var dateTimeInput = new ui.DateTimeInput(dateTimeInputArgs);
        dateTimeInput.render(container, renderMethod);
    } else if (field.Type == "DATE") {
        let dateInputArgs = _.assign({}, buildViewArgs, {
            zData: { DateFormat: "Date" }
        });

        var dateInput = new ui.DateInput(dateInputArgs);
        dateInput.render(container, renderMethod);
    } else if (field.Type == "TIME") {
        let timeInputArgs = _.assign({}, buildViewArgs, {
            zData: { DateFormat: "Time" }
        });

        var timeInput = new ui.TimeInput(timeInputArgs);
        timeInput.render(container, renderMethod);
    } else if (field.Type == "ENUM") {
        let comboBoxArgs = _.assign({}, buildViewArgs, {
            labelField: "Value",
            bindNumberValue: "CodeNumber",
            valueField: "Id",
            systemCode: true
        });

        var comboBox = new ui.ComboBox(comboBoxArgs);
        comboBox.render(container, renderMethod);
        var dataSource = _.find(z.user.companyData.UserDefinedLists, function (list) {
            return list.Id == field.UserDefinedListId;
        });

        if (dataSource) {

            if (args.containerPrefix) {
                field.fieldId = comboBoxArgs.id;
            }
            if ($(`#${field.fieldId}`).length > 0) {
                $(`#${field.fieldId}`).data("kendoComboBox").setDataSource(dataSource.Values);
            }
        }
    } else if (field.Type == "SIGNATURE") {
        let onClick = function () {
            var signatureId = $("#" + this.id).children().first().data("SignatureId");
            if (signatureId) {
                var signaturePopup = new SignaturePopup();
                signaturePopup.popUp({ Id: signatureId});
            }
        };

        let paneLabelLinkArgs = _.assign({}, buildViewArgs, {
            onClick: onClick
        });

        var signatureDisplay = new ui.PaneLabelLink(paneLabelLinkArgs);
        signatureDisplay.render(container, renderMethod);
    } else if (field.Type == "URL") {
        if (field.ReadOnly) {
            let onClick = function () {
                var url = $(`#${this.id}`).children().first().data("url");
                if (url) {
                    window.open(url, "_blank");
                }
            };

            let paneLabelLinkArgs = _.assign({}, buildViewArgs, {
                dataBind: "url",
                onClick: onClick
            });

            var urlDisplay = new ui.PaneLabelLink(paneLabelLinkArgs);
            urlDisplay.render(container, renderMethod);
        } else {
            let EURLOptions = _.assign({}, buildViewArgs, {
                readOnly: args.readOnly == undefined
                    ? false
                    : args.readOnly,
                args: args
            });

            var eURL = new ui.EURL(EURLOptions);
            eURL.render(container, renderMethod);
        }
    }

    if (buildViewArgs.readOnly && $("#" + field.fieldId).length > 0) {
        $("#" + field.fieldId).readOnly(true);
    }
}

export function getCustomFieldListValue(listId, valueId, propertyName) {
    var value = "---";
    propertyName = propertyName || "CodeNumber";

    $.each(z.user.companyData.UserDefinedLists, function (index, udl) {
        if (udl.Id == listId) {
            $.each(udl.Values, function (idx, udlValue) {
                if (udlValue.Id == valueId) {
                    value = udlValue[propertyName];
                    return false;
                }
            });
        }

    });

    return value;
}

export function getCustomFieldList(listId) {
    var list = null;
    $.each(z.user.companyData.UserDefinedLists, function (index, udl) {
        if (udl.Id == listId) {
            list = udl.Values;
            return false;
        }
        return true;
    });

    return list;
}
